import React, { Fragment, useCallback } from 'react';
import { AreaType, IArea, ILabelledStateAwareArea, IStateAwareArea } from "types/map";
import { isMapArea } from "components/Map/util";
import AreaMarker from "./AreaMarker";
import MapModalTooltipContext from 'components/Map/MapModalTooltipContext';

interface Props {
  areas: ILabelledStateAwareArea[],
  areaType?: AreaType,
  currentArea: IArea,
  fallback?: boolean,
  minimumZoomLevel?: number,
  onAreaClick: (e: any, area: IArea) => Promise<void>,
  onAreaSelect: (area?: IArea) => void,
  onTapAtLowZoomLevel: (area: IArea) => void,
  zoomLevel: number,
}

export default function DistrictLabelLayer({
  areas,
  currentArea,
  minimumZoomLevel,
  onAreaClick,
  onAreaSelect,
  onTapAtLowZoomLevel,
  zoomLevel,
}: Props) {

  const shouldAreaOverrideMinimumZoom = useCallback((area: IStateAwareArea) => {
    return area.areaKey === currentArea.areaKey;
  }, [currentArea]);

  const isInteractiveArea = useCallback(() => {
    return zoomLevel >= (minimumZoomLevel ?? 0);
  }, [minimumZoomLevel, zoomLevel]);

  return (
    <Fragment>
      {areas
        .filter(area => shouldAreaOverrideMinimumZoom(area) || zoomLevel >= (minimumZoomLevel ?? 0))
        .filter(isMapArea)
        .map((area) => (
          <MapModalTooltipContext.Consumer key={area.areaKey}>
            {({ openModalTooltip }) => (
              <AreaMarker
                area={area}
                currentArea={currentArea}
                interactive={isInteractiveArea()}
                onAreaSelect={onAreaSelect}
                onAreaClick={onAreaClick}
                openModalTooltip={openModalTooltip}
                onTapAtLowZoomLevel={onTapAtLowZoomLevel}
                zoomLevel={zoomLevel}
              />
            )}
          </MapModalTooltipContext.Consumer>
        ))}
    </Fragment>
  );
}

DistrictLabelLayer.displayName = 'DistrictLabelLayer';